var map = {
	"./banjo/1.mp4": 3898,
	"./cafler/1.mp4": 1999,
	"./dev/1.mp4": 1035,
	"./dibi/1.mp4": 9819,
	"./lapele/1.mp4": 5442,
	"./naggura/1.mp4": 784,
	"./pronatal/1.mp4": 6477,
	"./soultek/1.mp4": 2596
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6841;